<template>
  <div class="inner-card" :style="{ background: backgroundColor }">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <div class="field">
      <div class="field-title">
        <span :style="{ color: fontColor }">
          自傳
          <span class="en-text">Autobiography</span>
        </span>
      </div>
      <div class="field-value">
        <el-input
          class="w-100"
          type="textarea"
          :rows="30"
          maxlength="10000"
          show-word-limit
          placeholder="請輸入内容"
          v-model="autobiography"
        ></el-input>
      </div>
    </div>

    <div class="edit-btn-wrap">
      <!-- 儲存 -->
      <button type="button" class="put-btn" @click="saveAutobiography">
        {{ $t("BUTTON.RESUME_SAVE") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["source", "nextTab", "matchId"],
  name: "AseIDLAutobiography",

  data() {
    return {
      autobiography: "",

      backgroundColor: "#f1f1f1",
      fontColor: "#000",
    };
  },

  methods: {
    // 儲存 自傳
    saveAutobiography() {
      this.$api.idl
        .putAutobiography(this.source, {
          Autobiography: this.autobiography,
          UserId:
            this.source === "resume" ? this.$cookies.get("candidateId") : null,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "自傳儲存成功",
              type: "success",
              duration: 2000,
            });
            if (this.source === "resume") {
              this.$store.dispatch("GetResumeCompleteness");
            }
            this.getAutobiography();
            this.$emit("changeTab", this.nextTab);
          }
        });
    },

    // 取得 自傳
    getAutobiography() {
      const candidate =
        this.source === "resume"
          ? this.$cookies.get("candidateId")
          : this.matchId;
      this.updateLoading(true);
      this.$api.idl.getAutobiography(this.source, candidate).then((response) => {
        if (response.status === 200) {
          this.autobiography = response.data.Autobiography;
        }
        this.updateLoading(false);
      });
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getAutobiography();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>

<style lang="scss" scoped>
.field-title {
  .en-text {
    opacity: 0.6;
    font-size: 0.85em;
    margin-left: 5px;
  }
}
.edit-btn-wrap {
  .put-btn {
    margin-top: 20px;
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    color: #fff;
    background: #18c58b;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}
</style>
